var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#01A64F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6229 4.4955C12.3069 5.22675 12.6562 6.14475 12.6562 7.218C12.6562 8.30756 12.3069 9.22612 11.6224 9.95737C11.0751 10.5328 10.4214 10.8748 9.6615 10.9997V11.6376H11.2117V12.3379H9.64575V12.7114H11.2117V13.3644H9.6615V14.625H8.3385V13.365H6.80287V12.7114H8.35369V12.3379H6.80344V11.6376H8.33906V10.9839C7.59375 10.8596 6.94012 10.5171 6.39281 9.94162C5.69362 9.21037 5.34375 8.29181 5.34375 7.20281C5.34375 6.09806 5.67844 5.18006 6.37763 4.464C7.07625 3.73275 7.94362 3.375 9.00787 3.375C10.0569 3.375 10.9232 3.73275 11.6229 4.4955ZM10.1936 8.65013C10.4822 8.27663 10.6346 7.794 10.6346 7.20281C10.6346 6.62738 10.4828 6.14531 10.1633 5.77125C9.8595 5.38256 9.46406 5.19581 9.00787 5.19581C8.5365 5.19581 8.14162 5.38256 7.83731 5.75606C7.53244 6.12956 7.38056 6.59587 7.38056 7.18762C7.38056 7.794 7.533 8.27663 7.83731 8.65013C8.14162 9.02362 8.5365 9.21038 9.00731 9.21038C9.49444 9.21038 9.9045 9.02362 10.1936 8.65013Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMda);
export default __webpack_public_path__ + "static/media/mda.df1744b010025727498fd23d158b70cb.svg";
export { ForwardRef as ReactComponent };